/**
 * 色の小さな変換。
 *
 * ユーザーが選ぶアクセント色は hex で保存されるが、そこから派生色を作るときは
 * **必ず色相を取り出して相対で組むこと。** 派生色を絶対値（固定の hex）で置くと、
 * アクセントによって関係が変わり、テーマごとに当たり外れが出る。
 * （アバターのホロと環境光で実際にやらかしている）
 */

export interface Hsl {
  h: number;
  s: number;
  l: number;
}

export const hslOf = (hex: string): Hsl => {
  const [r, g, b] = [1, 3, 5].map(i => parseInt(hex.substr(i, 2), 16) / 255);
  const mx = Math.max(r, g, b);
  const mn = Math.min(r, g, b);
  const d = mx - mn;
  const l = (mx + mn) / 2;
  if (!d) return { h: 0, s: 0, l: Math.round(l * 100) };
  const s = d / (1 - Math.abs(2 * l - 1));
  const raw = mx === r ? ((g - b) / d) % 6 : mx === g ? (b - r) / d + 2 : (r - g) / d + 4;
  return {
    h: Math.round((raw * 60 + 360) % 360),
    s: Math.round(s * 100),
    l: Math.round(l * 100),
  };
};

export const clamp = (v: number, lo: number, hi: number): number =>
  Math.min(hi, Math.max(lo, v));

export const wrapHue = (h: number): number => ((h % 360) + 360) % 360;
